(function() {
  var STATUS_URL = "https://api.bestfy.io/public/shopify/status";
  var CHECKOUT_URL = "https://api.bestfy.io/public/shopify/checkout";
  var FALLBACK_URL = "https://api.bestfy.io/public/shopify/checkout/fallback";
  var STATUS_CACHE_KEY = "bestfy:integration-active";
  var STATUS_CACHE_TTL_MS = 300000;
  var UTM_COOKIE = "bestfy_utms";
  var TBLCI_COOKIE = "bestfy_tblci";
  var FBCLID_COOKIE = "bestfy_fbclid";
  var GCLID_COOKIE = "bestfy_gclid";
  var SKIP_CART = false;
  var CART_SIGNATURE_KEY = "bestfy:cart-signature";
  var CART_READ_MAX_ATTEMPTS = 8;
  var CART_READ_RETRY_DELAYS_MS = [500, 1500, 3000, 5000, 5000, 5000, 5000];
  var CART_READ_PATIENCE_MS = 4000;
  var CART_READ_BUDGET_MS = 30000;
  var API_ORIGIN = "https://api.bestfy.io";
  var CHECKOUT_MAX_ATTEMPTS = 12;
  var CHECKOUT_MAX_SLOW_ATTEMPTS = 3;
  var CHECKOUT_RETRY_DELAYS_MS = [0, 500, 1500, 3000, 5000, 5000, 5000, 5000, 5000, 5000, 5000];
  var CHECKOUT_PATIENCE_BUDGET_MS = 45000;
  var CHECKOUT_ATTEMPT_PATIENCE_MS = 10000;
  var HELD_STATUS_WAIT_MS = 3000;
  var BUSY_OPACITY = "0.6";
  var MAX_REPORTED_ITEMS = 25;
  var REPORTED_LABEL_MAX_LENGTH = 60;
  var REPORTED_TITLE_MAX_LENGTH = 80;
  var LINE_PROPERTY_NAME_MAX_LENGTH = 100;
  var LINE_PROPERTY_VALUE_MAX_LENGTH = 750;
  var CHECKOUT_BODY_BUDGET_BYTES = 6500;
  var HIDE_STYLE_ID = "bestfy-hide-dynamic-checkout";
  var PROGRESS_NOTICE_ID = "bestfy-checkout-progress";
  var PROGRESS_MESSAGE = "Preparando seu pagamento seguro…";
  var SLOW_NETWORK_MESSAGE = "Sua conexão está lenta. Estamos quase lá, não feche esta página.";
  var SLOW_NETWORK_NOTICE_DELAY_MS = 5000;
  var LEAVING_GRACE_MS = 8000;
  /* O data-shop da tag vem primeiro: no <head> o window.Shopify pode ainda não existir (o content_for_header
     que o define vem depois ou está comentado). O window.Shopify cobre uma tag que o lojista copiou para o body
     sem o atributo. */
  var currentScript = document.currentScript;
  var shop =
    (currentScript && currentScript.getAttribute("data-shop")) ||
    (window.Shopify && window.Shopify.shop) ||
    window.location.hostname;

  /* Sem fetch/Promise não dá para concluir o fluxo; não interceptamos (um
     preventDefault sem POST travaria o comprador) e o checkout nativo segue. */
  if (!window.fetch || !window.Promise) return;

  /* Tag duplicada no layout (reformatada ou movida para um snippet pelo lojista) carregaria o script duas vezes:
     dois listeners e dois POSTs de resolve por clique. */
  if (window.__bestfyCheckoutRedirect) return;
  window.__bestfyCheckoutRedirect = true;

  var EXCLUDED_NAMES = {
    update: 1, add: 1, "add-to-cart": 1, plus: 1, minus: 1, remove: 1, clear: 1
  };

  var resolveInFlight = false;
  var wentNative = false;
  var addInFlight = false;
  var replayedNativeAdd = false;
  var busy = null;
  var checkoutOrigin = null;
  var slowNetworkTimer = null;
  var activeFlow = null;
  var waitingAttempt = null;
  var noticeShownAt = null;
  var handedOff = false;
  var buyerLeaving = false;
  var clickGeneration = 0;
  var leavingGraceTimer = null;

  function lc(value) {
    return (value || "").toLowerCase();
  }

  function attr(el, name) {
    return (el.getAttribute && el.getAttribute(name)) || "";
  }

  function cacheGet(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function cacheSet(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  function cacheRemove(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      return;
    }
  }

  /* O cache guarda "true:<epoch-ms>:<origem do checkout>" / "false:<epoch-ms>" e expira em 5 min:
     sem TTL, um "false" gravado antes de o lojista ativar a integração
     manteria a sessão inteira indo para o checkout nativo. Valor vencido ou em
     formato inesperado vira desconhecido e é revalidado no warmStatus. A origem vem
     depois do epoch para o valor gravado antes dela continuar legível. */
  var activeState = (function() {
    var cached = cacheGet(STATUS_CACHE_KEY);
    if (!cached) return null;
    var separator = cached.indexOf(":");
    if (separator === -1) return null;
    var rest = cached.slice(separator + 1);
    var writtenAt = parseInt(rest, 10);
    if (!writtenAt || Date.now() - writtenAt > STATUS_CACHE_TTL_MS) return null;
    var originSeparator = rest.indexOf(":");
    if (originSeparator !== -1) checkoutOrigin = rest.slice(originSeparator + 1) || null;
    var flag = cached.slice(0, separator);
    if (flag === "true") return true;
    if (flag === "false") return false;
    return null;
  })();

  /* As carteiras somem antes de o tema pintá-las: o script roda no <head>, e esperar o /status deixava o
     botão do PayPal clicável na primeira visita. Só o status definitivamente inativo as devolve
     (showDynamicCheckout). */
  if (activeState !== false) hideDynamicCheckout();

  function saveUtms() {
    var params = new URLSearchParams(window.location.search);
    var utms = {};
    var found = false;

    /* Reescritores de URL (ex.: Utmify) acrescentam a família utm_* inteira preenchendo os ausentes
       como vazio; valor vazio não é atribuição e o backend o descartaria de qualquer forma. */
    params.forEach(function(value, key) {
      if (key.indexOf("utm_") === 0 && value) {
        utms[key] = value;
        found = true;
      }
    });

    if (found) {
      document.cookie =
        UTM_COOKIE + "=" + encodeURIComponent(JSON.stringify(utms)) +
        "; path=/; max-age=604800";
    }
  }

  function readUtms() {
    var match = document.cookie.match(
      new RegExp("(?:^|; )" + UTM_COOKIE + "=([^;]*)")
    );
    if (!match) return null;

    try {
      return JSON.parse(decodeURIComponent(match[1]));
    } catch (error) {
      return null;
    }
  }

  /* Click ids (tblci/fbclid) são case-sensitive e opacos: capturados íntegros, sem normalização
     nem truncamento — valor acima do teto do backend é ignorado (não truncado), senão viraria um
     cookie de 7 dias reenviado em todo checkout. Como nas UTMs, só sobrescrevem quando presentes
     na URL (o último clique vence). */
  function saveClickId(param, cookie, maxLength) {
    var params = new URLSearchParams(window.location.search);
    var value = params.get(param);
    if (value && value.length <= maxLength) {
      document.cookie =
        cookie + "=" + encodeURIComponent(value) +
        "; path=/; max-age=604800";
    }
  }

  function readClickId(cookie) {
    var match = document.cookie.match(
      new RegExp("(?:^|; )" + cookie + "=([^;]*)")
    );
    if (!match) return null;

    try {
      return decodeURIComponent(match[1]);
    } catch (error) {
      return null;
    }
  }

  /* Identidade do GA4 no domínio da loja: client_id do cookie _ga ("GA1.1.<random>.<ts>" -> últimos
     2 segmentos) e session_id de cada cookie _ga_<container> (formatos GS1 "GS1.1.<sid>..." e GS2
     "GS2.1.s<sid>$..."). Cada propriedade GA4 tem sessão própria, então o session_id vai num mapa
     "G-<container>" -> sid e o backend entrega a cada stream o da propriedade dele. Lidos na hora do
     checkout (os cookies do gtag já são duráveis na loja); valor malformado é descartado. */
  function readGaClientId() {
    var value = readClickId("_ga");
    if (!value) return null;

    var parts = value.split(".");
    if (parts.length < 4) return null;

    var clientId = parts.slice(-2).join(".");
    return new RegExp("^[0-9]+[.][0-9]+$").test(clientId) ? clientId : null;
  }

  function parseGaSessionCookie(value) {
    var parts = value.split(".");
    if (parts.length < 3) return null;

    var digitsOnly = new RegExp("^[0-9]+$");
    if (parts[0] === "GS2") {
      var fields = parts[2].split("$");
      for (var i = 0; i < fields.length; i++) {
        if (fields[i].charAt(0) === "s" && digitsOnly.test(fields[i].slice(1))) {
          return fields[i].slice(1);
        }
      }
      return null;
    }

    return digitsOnly.test(parts[2]) ? parts[2] : null;
  }

  function readGaSessionIds() {
    var matches = document.cookie.match(
      new RegExp("(?:^|; )_ga_[^=]+=[^;]*", "g")
    );
    if (!matches) return null;

    var sessionIds = {};
    var found = false;
    for (var i = 0; i < matches.length; i++) {
      var cookie = matches[i].replace(new RegExp("^; "), "");
      var separatorIndex = cookie.indexOf("=");
      var container = cookie.slice("_ga_".length, separatorIndex);
      var value;
      try {
        value = decodeURIComponent(cookie.slice(separatorIndex + 1));
      } catch (error) {
        continue;
      }

      var sessionId = parseGaSessionCookie(value);
      if (!sessionId) continue;

      sessionIds["G-" + container] = sessionId;
      found = true;
    }

    return found ? sessionIds : null;
  }

  /* Valor único legado, aceito pelo backend até o contract do gaSessionId: só existe sem ambiguidade. */
  function readGaSessionId(sessionIds) {
    if (!sessionIds) return null;

    var keys = Object.keys(sessionIds);
    return keys.length === 1 ? sessionIds[keys[0]] : null;
  }

  function hideDynamicCheckout() {
    if (document.getElementById(HIDE_STYLE_ID)) return;
    var style = document.createElement("style");
    style.id = HIDE_STYLE_ID;
    /* Oculta o container (no documento pai) dos botões de checkout dinâmico/
       acelerado da Shopify nas duas marcações conhecidas: a do formulário de
       produto (data-shopify="payment-button" / .shopify-payment-button) e a do
       carrinho/gaveta, gerada por content_for_additional_checkout_buttons
       (.additional-checkout-buttons / shopify-accelerated-checkout[-cart]).
       Ocultar o container remove o iframe da carteira (PayPal/Shop Pay), que
       não conseguimos interceptar a partir do documento pai. */
    style.textContent = '[data-shopify="payment-button"],[data-shopify="dynamic-checkout-cart"],.shopify-payment-button,.additional-checkout-buttons,shopify-accelerated-checkout,shopify-accelerated-checkout-cart{display:none !important;}';
    (document.head || document.documentElement).appendChild(style);
  }

  function showDynamicCheckout() {
    var style = document.getElementById(HIDE_STYLE_ID);
    if (style && style.parentNode) style.parentNode.removeChild(style);
  }

  /* Só um 200 com o boolean é resultado definitivo. Rate limit, 5xx e erro de rede deixam o status
     desconhecido (null) e sem cache: tratá-los como inativo mandaria em silêncio todos os cliques da
     sessão para o checkout nativo, enquanto seguir para o resolve custa uma requisição e, se ela
     também falhar, cai no fallback reportado. */
  function warmStatus() {
    return fetch(STATUS_URL + "?shop=" + encodeURIComponent(shop))
      .then(function(response) { return response.ok ? response.json() : null; })
      .then(function(data) {
        if (!data || typeof data.active !== "boolean") return null;
        activeState = data.active;
        checkoutOrigin = typeof data.checkoutOrigin === "string" ? data.checkoutOrigin : null;
        cacheSet(
          STATUS_CACHE_KEY,
          String(data.active) + ":" + Date.now() + (checkoutOrigin ? ":" + checkoutOrigin : "")
        );
        if (!data.active) showDynamicCheckout();
        return data.active;
      })
      .catch(function() {
        return null;
      });
  }

  var statusPromise =
    activeState === null ? warmStatus() : Promise.resolve(activeState);

  function pathOf(url) {
    var value = lc(url);
    var scheme = value.indexOf("://");
    if (scheme !== -1) {
      var rest = value.slice(scheme + 3);
      var slash = rest.indexOf("/");
      value = slash === -1 ? "/" : rest.slice(slash);
    }
    var query = value.indexOf("?");
    if (query !== -1) value = value.slice(0, query);
    var hash = value.indexOf("#");
    if (hash !== -1) value = value.slice(0, hash);
    return value;
  }

  function isLocaleSegment(segment) {
    if (segment.length !== 2 && segment.length !== 5) return false;
    for (var i = 0; i < segment.length; i++) {
      var ch = segment.charAt(i);
      if (segment.length === 5 && i === 2) {
        if (ch !== "-") return false;
      } else if (ch < "a" || ch > "z") {
        return false;
      }
    }
    return true;
  }

  /* Casa /checkout e /checkouts/... (a URL da sessão de checkout já criada) no início do path ou precedidos
     só por segmentos de locale (/fr, /en-ca); páginas como /pages/checkout não são gatilho de compra. */
  function leadsToCheckout(path) {
    var i = path.indexOf("/checkout");
    if (i === -1) return false;
    var end = path.charAt(i + 9) === "s" ? i + 10 : i + 9;
    var after = path.charAt(end);
    if (after !== "" && after !== "/" && after !== "?" && after !== "#") {
      return false;
    }
    var prefixSegments = path.slice(0, i).split("/");
    for (var s = 0; s < prefixSegments.length; s++) {
      if (prefixSegments[s] && !isLocaleSegment(prefixSegments[s])) {
        return false;
      }
    }
    return true;
  }

  function leadsToCartAdd(path) {
    return path.indexOf("/cart/add") !== -1;
  }

  /* Compara pelo sufixo porque o path do carrinho chega de duas formas que não reduzem a
     "/cart": prefixado por locale (/fr/cart) e com o hostname colado pelo tema, que monta o
     destino concatenando window.location.hostname. */
  function isCartPath(path) {
    return path.slice(-5) === "/cart";
  }

  function isCartMutation(path) {
    return (
      path.indexOf("/cart/update") !== -1 ||
      path.indexOf("/cart/change") !== -1 ||
      leadsToCartAdd(path)
    );
  }

  function getForm(el) {
    if (el.form) return el.form;
    var node = el.parentNode;
    while (node && node.nodeType === 1) {
      if (lc(node.tagName) === "form") return node;
      node = node.parentNode;
    }
    return null;
  }

  function isSubmitControl(el) {
    var tag = lc(el.tagName);
    var type = lc(attr(el, "type"));
    if (tag === "button") return type === "submit" || type === "";
    if (tag === "input") return type === "submit" || type === "image";
    return false;
  }

  function isCartCheckoutLink(el) {
    var href = pathOf(attr(el, "href"));
    if (!isCartPath(href)) return false;
    if (isCartMutation(href)) return false;
    var cls = lc(attr(el, "class"));
    return cls.indexOf("checkout") !== -1;
  }

  function isCheckoutTrigger(el) {
    if (!el || el.nodeType !== 1) return false;
    var tag = lc(el.tagName);
    var name = lc(attr(el, "name"));

    if (name === "checkout") return true;
    if (tag === "a") {
      if (leadsToCheckout(pathOf(attr(el, "href")))) return true;
      if (isCartCheckoutLink(el)) return true;
      return false;
    }
    if (lc(attr(el, "data-shopify")) === "payment-button") return true;

    if (isSubmitControl(el)) {
      if (EXCLUDED_NAMES[name] === 1) return false;

      var formaction = pathOf(attr(el, "formaction"));
      if (formaction) {
        if (isCartMutation(formaction)) return false;
        if (leadsToCheckout(formaction)) return true;
      }

      var form = getForm(el);
      var action = form ? pathOf(attr(form, "action")) : "";
      if (leadsToCheckout(action)) return true;
      /* Enviar o formulário do carrinho (action /cart) leva ao checkout. */
      if (isCartPath(action)) return true;
    }

    return false;
  }

  /* Exige verbo e objeto como termos separados em vez da frase inteira: assim o rótulo casa com
     qualquer espaçamento ou quebra de linha entre as palavras, e "Finalizar cadastro", "Finalizar
     avaliação" e "Finalizar personalização" — que existem na mesma loja, em páginas que não são
     carrinho — ficam de fora. Interceptar um desses cancelaria o fluxo em que o comprador está,
     porque o stopPropagation descarta o handler original do elemento junto. */
  function hasCheckoutIntent(label) {
    if (label.indexOf("checkout") !== -1) return true;
    if (label.indexOf("finaliz") === -1 && label.indexOf("conclu") === -1) return false;
    return label.indexOf("compra") !== -1 || label.indexOf("pedido") !== -1;
  }

  /* Controle que altera o carrinho nunca é gatilho de checkout, por mais que o rótulo diga o
     contrário: interceptar cancelaria o POST /cart/add e o comprador fecharia o pedido sem o
     produto que estava vendo. O nome não basta como sinal, porque tema que monta o botão por
     snippet costuma não emitir name nenhum; quem decide é o destino do formulário. */
  function isCartMutationControl(el) {
    if (!isSubmitControl(el)) return false;
    if (EXCLUDED_NAMES[lc(attr(el, "name"))] === 1) return true;

    var formaction = pathOf(attr(el, "formaction"));
    if (formaction) return isCartMutation(formaction);

    var form = getForm(el);
    return form ? isCartMutation(pathOf(attr(form, "action"))) : false;
  }

  /* Botão ou âncora do carrinho que só declara a intenção de compra no rótulo. Cobre o <button
     type="button" onclick="yampiClick()"> deixado por checkout de concorrente, que não é submit
     nem navega para lugar nenhum, e a âncora que o tema aponta para /cart mas rotula como
     finalizar. Âncora para qualquer outro destino fica fora: o rótulo sozinho não justifica
     sequestrar uma navegação, e o "ver carrinho" do header precisa seguir levando ao carrinho.

     A âncora de /cart exige SKIP_CART: ela aterrissa na página do carrinho, e com o pular carrinho
     desligado é lá que o lojista quer o comprador — o botão daquela página já é interceptado pela
     heurística geral, então não interceptar aqui custa um clique, não o fluxo. A âncora de /cart
     reconhecida pela classe (isCartCheckoutLink) fica fora do gate de propósito, por ser anterior a
     esta regra: gatear mudaria o comportamento de lojas já em produção.

     A tag é conferida antes do rótulo porque ler textContent serializa a subárvore inteira, e o
     tamanho dela é decidido pelo HTML do tema, não por nós. */
  function isLabeledCheckout(el) {
    var tag = lc(el.tagName);
    if (tag !== "button" && tag !== "a") return false;
    if (!hasCheckoutIntent(lc(el.textContent))) return false;
    if (isCartMutationControl(el)) return false;
    if (tag === "button") return true;

    return SKIP_CART && isCartPath(pathOf(attr(el, "href")));
  }

  /* Sobe do alvo até o primeiro <button>/<a> e avalia só ele. Clique no ícone de cadeado ou no
     <span> de estilo dentro do botão é clique no botão, e o HTML proíbe conteúdo interativo
     aninhado, então não existe um segundo gatilho lá dentro. Parar no primeiro é o que impede um
     botão interno sem rótulo de levar a busca até uma âncora externa, único caso em que a regra
     decidiria por um elemento que o comprador não clicou. */
  function findLabeledTrigger(node) {
    while (node && node !== document) {
      if (node.nodeType === 1) {
        var tag = lc(node.tagName);
        if (tag === "button" || tag === "a") {
          return isLabeledCheckout(node) ? node : null;
        }
      }
      node = node.parentNode;
    }

    return null;
  }

  function findTrigger(node) {
    while (node && node !== document) {
      if (node.nodeType === 1 && isCheckoutTrigger(node)) return node;
      node = node.parentNode;
    }
    return null;
  }

  function triggerLabel(el) {
    if (!el) return undefined;
    var tag = lc(el.tagName);
    var text = "";
    if (tag === "input") text = attr(el, "value");
    if (tag === "button" || tag === "a") text = el.textContent || "";

    return text.replace(/\s+/g, " ").trim().slice(0, REPORTED_LABEL_MAX_LENGTH) || undefined;
  }

  /* Elemento com display:none não tem caixa: um clique nele não veio de um comprador, e sim de um robô que
     dispara o click() em todo botão de finalizar do DOM, inclusive o da notificação de carrinho escondida. */
  function isRendered(el) {
    return !!el && !!el.getClientRects && el.getClientRects().length > 0;
  }

  /* Carrinho vazio com o cookie presente é carrinho que existia e voltou vazio no /cart.json; sem o cookie, o
     comprador nunca adicionou nada (a Shopify só grava o cookie quando o carrinho ganha a primeira linha). */
  function hasCartCookie() {
    return new RegExp("(?:^|; )cart=").test(document.cookie);
  }

  function referrerHost() {
    try {
      return document.referrer ? new URL(document.referrer).hostname : undefined;
    } catch (error) {
      return undefined;
    }
  }

  function pageAgeMs() {
    return window.performance && window.performance.now
      ? Math.round(window.performance.now())
      : undefined;
  }

  /* fetch com keepalive, nunca sendBeacon: o beacon sai com tipo "ping", que o Brave (modo padrão) e
     outros bloqueadores barram quando vai para outro domínio, e o keepalive sobrevive igual à navegação
     do goNative. A pageUrl vai sem a query: os parâmetros de campanha só aumentam a chance de o DTO
     recusar o report inteiro (tamanho, padrões do IsSafeString), e o caminho já diz em que página foi. */
  function reportFallback(reason, attempt, details) {
    var el = attempt.el;
    var payload = {
      shop: shop,
      reason: reason,
      pageUrl: window.location.origin + window.location.pathname,
      triggerRule: attempt.rule,
      triggerLabel: triggerLabel(el),
      triggerVisible: isRendered(el),
      webdriver: navigator.webdriver === true,
      hasCartCookie: hasCartCookie(),
      pageAgeMs: pageAgeMs(),
      referrerHost: referrerHost(),
      items: attempt.items,
      itemCount: attempt.itemCount,
      network: readNetwork()
    };
    for (var key in details) payload[key] = details[key];

    fetch(FALLBACK_URL, {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(function() {
      return;
    });
  }

  /* Network Information API: só o Chromium a tem (inclusive o webview do Instagram e do Facebook no Android),
     e é ela que separa a rede lenta do comprador de um backend lento num timeout. */
  function readNetwork() {
    var connection = navigator.connection;
    if (!connection) return undefined;

    return {
      effectiveType: connection.effectiveType,
      rttMs: connection.rtt,
      downlinkMbps: connection.downlink,
      saveData: connection.saveData
    };
  }

  /* O TypeError genérico ("Load failed", "Failed to fetch") é igual para rede caída, bloqueio sem CORS e
     página em segundo plano; a duração e o estado da página no momento da falha são o que os separa. */
  function failureDetails(error, startedAt, attempts, previousFailures) {
    return {
      httpStatus: error && error.httpStatus,
      errorMessage: errorMessage(error),
      elapsedMs: Date.now() - startedAt,
      online: navigator.onLine,
      pageHidden: document.visibilityState === "hidden",
      attempts: attempts,
      previousFailures: previousFailures
    };
  }

  function errorMessage(error) {
    return error && error.message ? error.message : String(error);
  }

  /* Encaminha ao checkout nativo por navegação direta, nunca reenviando o
     clique/submit original: replays sintéticos dependem do tema (validação do
     form, JS próprio, semântica de submitter) e falham em silêncio. GET
     /checkout é o ponto de entrada universal da Shopify e monta o checkout a
     partir do carrinho salvo no cookie (carrinho vazio cai na página /cart). */
  function goNative(el) {
    if (wentNative || buyerLeaving) return;
    wentNative = true;

    /* O href da âncora só é reaproveitado quando leva ao próprio checkout. Desde que a regra de
       rótulo passou a reconhecer âncora de /cart, reaproveitar às cegas devolveria o comprador ao
       carrinho em todo fallback — carrinho vazio, status inativo, erro do backend —, e ele
       reencontraria o mesmo botão num laço. */
    if (
      el &&
      lc(el.tagName) === "a" &&
      el.href &&
      leadsToCheckout(pathOf(attr(el, "href")))
    ) {
      window.location.href = el.href;
      return;
    }

    window.location.href = "/checkout";
  }

  function cartSignature(cart) {
    var items = (cart && cart.items) || [];

    return items.map(function(item) {
      return item.variant_id + "x" + item.quantity;
    }).join(",");
  }

  function rememberCart(cart) {
    cacheSet(CART_SIGNATURE_KEY, cartSignature(cart));
  }

  /* Repetir é seguro: é um GET. Falha de rede, 5xx e 429 (a borda da Shopify devolve de vez em quando um 503
     "upstream connect error") e corpo que não é JSON repetem; outro 4xx daria o mesmo numa nova leitura e
     encerra na hora. A falha que mais derruba a leitura é o aparelho sem rede, e nela o checkout nativo
     também não carregaria: desistir cedo não salva o comprador. Por isso as esperas crescem até 5 s e ficam
     aí, com a última leitura aos ~25 s, e a rede que volta (evento online) antecipa a próxima. O /cart.json
     volta em menos de 500 ms, então a leitura sem resposta em CART_READ_PATIENCE_MS está presa e ganha outra
     em paralelo. */
  function readCart() {
    return fetch("/cart.json").then(function(response) {
      if (response.ok) {
        return response.json().then(function(cart) {
          return { result: cart };
        });
      }

      var error = new Error("HTTP " + response.status);
      error.httpStatus = response.status;
      if (response.status >= 500 || response.status === 429) throw error;
      return { refusal: error };
    });
  }

  function toLineTriple(item) {
    return {
      shopifyProductId: item.product_id,
      shopifyVariantId: item.variant_id,
      quantity: item.quantity
    };
  }

  function toLineItem(item) {
    return withLineProperties(item, true);
  }

  function toVisibleLineItem(item) {
    return withLineProperties(item, false);
  }

  function withLineProperties(item, includePrivate) {
    var lineItem = toLineTriple(item);
    var properties = toLineProperties(item.properties, includePrivate);
    if (properties) lineItem.properties = properties;
    return lineItem;
  }

  /* A personalização que o comprador preencheu (line item properties). Truncada nos tetos da Shopify, que o
     resolve também aplica, para o texto de um campo livre não estourar o corpo. As privadas (nome com "_") são
     dado técnico de apps, às vezes grande (prévia, configuração), e são as primeiras a sair quando o corpo não cabe. */
  function toLineProperties(properties, includePrivate) {
    if (!properties || typeof properties !== "object") return undefined;

    var list = [];
    Object.keys(properties).forEach(function(name) {
      var value = properties[name];
      if (typeof value === "number") value = String(value);
      if (typeof value !== "string" || value.trim() === "") return;
      if (!includePrivate && name.charAt(0) === "_") return;
      list.push({
        name: truncateText(name, LINE_PROPERTY_NAME_MAX_LENGTH),
        value: truncateText(value, LINE_PROPERTY_VALUE_MAX_LENGTH)
      });
    });

    return list.length > 0 ? list : undefined;
  }

  // Sem partir um emoji ao meio: meio par substituto viraria um caractere inválido no texto.
  function truncateText(text, maxLength) {
    var cut = text.slice(0, maxLength);
    return /[\uD800-\uDBFF]$/.test(cut) ? cut.slice(0, -1) : cut;
  }

  function toReportedItem(item) {
    var reported = toLineTriple(item);
    reported.title = (item.product_title || "").slice(0, REPORTED_TITLE_MAX_LENGTH) || undefined;
    return reported;
  }

  function bodyBytes(payload) {
    var body = JSON.stringify(payload);
    return window.TextEncoder ? new TextEncoder().encode(body).length : body.length * 3;
  }

  /* Numa rede lenta o caminho até o checkout leva dezenas de segundos, e só o botão esmaecido parece erro: o
     comprador recarrega ou fecha a página. O aviso cobre a página desde o clique até a navegação, e a segunda
     linha diz que a demora é da conexão. Os estilos são inline para não depender do CSS do tema. */
  function showProgressNotice() {
    if (document.getElementById(PROGRESS_NOTICE_ID)) return;

    noticeShownAt = Date.now();
    window.addEventListener("beforeunload", abandonWait);
    var overlay = document.createElement("div");
    overlay.id = PROGRESS_NOTICE_ID;
    overlay.setAttribute("role", "status");
    overlay.setAttribute("aria-live", "polite");
    overlay.style.cssText =
      "position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483647;display:flex;" +
      "align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,0.5);" +
      "width:100%;height:100%;max-width:none;max-height:none;margin:0;border:0;box-sizing:border-box;";

    var box = document.createElement("div");
    box.style.cssText =
      "max-width:320px;padding:24px;border-radius:8px;background:#fff;color:#111;" +
      "font:16px/1.4 sans-serif;text-align:center;box-shadow:0 4px 24px rgba(0,0,0,0.2);";

    var spinner = document.createElement("div");
    spinner.setAttribute("aria-hidden", "true");
    spinner.style.cssText =
      "width:36px;height:36px;margin:0 auto;border:4px solid #ddd;border-top-color:#111;" +
      "border-radius:50%;box-sizing:border-box;";
    box.appendChild(spinner);
    spinWhileWaiting(spinner);

    var message = document.createElement("p");
    message.style.cssText = "margin:12px 0 0;";
    message.textContent = PROGRESS_MESSAGE;
    box.appendChild(message);

    overlay.appendChild(box);
    (document.body || document.documentElement).appendChild(overlay);
    showInTopLayer(overlay);

    slowNetworkTimer = setTimeout(function() {
      var slowMessage = document.createElement("p");
      slowMessage.style.cssText = "margin:8px 0 0;font-size:14px;color:#555;";
      slowMessage.textContent = SLOW_NETWORK_MESSAGE;
      box.appendChild(slowMessage);
    }, SLOW_NETWORK_NOTICE_DELAY_MS);
  }

  /* Web Animations e não SMIL: a rotação roda no compositor e continua girando com a thread principal
     ocupada pelo JS do tema e pela navegação, onde o SVG animado congelava em 3G. Sem a API, o anel fica
     parado e o texto avisa. */
  function spinWhileWaiting(element) {
    if (!element.animate) return;

    element.animate(
      [{ transform: "rotate(0deg)" }, { transform: "rotate(360deg)" }],
      { duration: 900, iterations: Infinity }
    );
  }

  /* A gaveta de carrinho aberta com dialog.showModal() (Horizon e outros) fica na top layer, acima de
     qualquer z-index: o aviso só a cobre entrando nela também, como popover aberto depois dela. Sem a Popover
     API (iOS anterior ao 17), o aviso fica com o z-index, que cobre todo o resto. */
  function showInTopLayer(element) {
    if (!element.showPopover) return;

    try {
      element.setAttribute("popover", "manual");
      element.showPopover();
    } catch (error) {
      element.removeAttribute("popover");
    }
  }

  function hideProgressNotice() {
    noticeShownAt = null;
    window.removeEventListener("beforeunload", abandonWait);
    clearTimeout(slowNetworkTimer);
    var overlay = document.getElementById(PROGRESS_NOTICE_ID);
    if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
  }

  /* Abre DNS, TCP e TLS enquanto o carrinho é lido e o resolve corre: numa rede lenta cada handshake custa
     vários round trips, que antes só começavam depois da etapa anterior. O fetch do resolve é cross-origin
     sem credenciais e só reaproveita uma conexão aberta no mesmo modo (crossorigin anonymous); a navegação ao
     checkout leva cookies e usa a conexão sem o atributo. */
  function preconnect(origin, anonymous) {
    if (!origin) return;

    var link = document.createElement("link");
    link.rel = "preconnect";
    link.href = origin;
    if (anonymous) link.crossOrigin = "anonymous";
    (document.head || document.documentElement).appendChild(link);
  }

  /* Numa rede ruim o resolve pode levar segundos, e um botão parado parece quebrado. O retorno é só
     opacidade e aria-busy no próprio gatilho, sem mexer no layout do tema; formulário (submit e pular
     carrinho) fica de fora, porque esmaecer o form inteiro confunde mais do que ajuda. */
  function markBusy(el) {
    if (!el || !el.style || lc(el.tagName) === "form") return;

    busy = { el: el, opacity: el.style.opacity, ariaBusy: attr(el, "aria-busy") };
    el.setAttribute("aria-busy", "true");
    el.style.opacity = BUSY_OPACITY;
  }

  function releaseResolve() {
    resolveInFlight = false;

    if (!busy) return;

    busy.el.style.opacity = busy.opacity;
    if (busy.ariaBusy) {
      busy.el.setAttribute("aria-busy", busy.ariaBusy);
    } else {
      busy.el.removeAttribute("aria-busy");
    }
    busy = null;
  }

  function fallBackToNative(reason, attempt, details) {
    endFlow();
    releaseResolve();
    reportFallback(reason, attempt, details);
    goNative(attempt.el);
  }

  /* A leitura do carrinho tem o próprio prazo, CART_READ_BUDGET_MS, e o resolve tem o dele (ver
     postCheckout): elas falham por motivos diferentes (aparelho sem rede, rede lenta até a API), e o tempo
     gasto esperando a rede voltar não pode encurtar o resolve que vem depois, numa rede que talvez ainda
     esteja lenta. */
  function resolveCheckout(attempt) {
    if (resolveInFlight || buyerLeaving) return;
    resolveInFlight = true;
    markBusy(attempt.el);
    preconnect(API_ORIGIN, true);
    preconnect(checkoutOrigin, false);

    var startedAt = Date.now();
    var flow = { run: null, readingCart: true, timers: [] };
    activeFlow = flow;

    flow.timers.push(setTimeout(function() {
      if (flow.readingCart) flow.run.expire(new Error("timeout"));
    }, CART_READ_BUDGET_MS));

    flow.run = runAttempts(
      {
        maxAttempts: CART_READ_MAX_ATTEMPTS,
        patienceMs: CART_READ_PATIENCE_MS,
        retryDelaysMs: CART_READ_RETRY_DELAYS_MS
      },
      readCart,
      function(outcome) {
        flow.readingCart = false;

        if (outcome.result) {
          requestCheckout(flow, attempt, outcome.result, outcome.failures);
          return;
        }

        var previousFailures = outcome.failures.length > 0 ? outcome.failures : undefined;
        fallBackToNative(
          "cart_read_failed",
          attempt,
          failureDetails(outcome.refusal || outcome.error, startedAt, outcome.attempts, previousFailures)
        );
      }
    );
  }

  /* Cancela os prazos e as tentativas do clique em andamento; nenhum callback dele roda depois daqui. */
  function endFlow() {
    if (!activeFlow) return;

    for (var i = 0; i < activeFlow.timers.length; i++) clearTimeout(activeFlow.timers[i]);
    activeFlow.run.cancel();
    activeFlow = null;
  }

  function requestCheckout(flow, attempt, cart, cartReadFailures) {
    var items = (cart && cart.items) || [];

    if (items.length === 0) {
      fallBackToNative("cart_empty", attempt);
      return;
    }

    rememberCart(cart);
    attempt.items = items.slice(0, MAX_REPORTED_ITEMS).map(toReportedItem);
    attempt.itemCount = items.length;

    /* O ALB/WAF de dev/prod bloqueia corpos > 8 KB (403 sem headers CORS); o cart.json cru chegou a ~4 KB com 2
       itens, então enviamos só as triplas dos line items e a personalização deles. Se a personalização levar o
       corpo além do orçamento (com folga para as falhas anteriores que as novas tentativas acrescentam), saem
       primeiro as propriedades privadas e, se ainda não couber, a personalização inteira: perder a personalização
       é melhor que mandar o comprador ao checkout nativo. */
    var gaSessionIds = readGaSessionIds();
    var payload = {
      shop: shop,
      cartToken: cart.token,
      items: items.map(toLineItem),
      utms: readUtms(),
      tblci: readClickId(TBLCI_COOKIE),
      fbclid: readClickId(FBCLID_COOKIE),
      gclid: readClickId(GCLID_COOKIE),
      gaClientId: readGaClientId(),
      gaSessionId: readGaSessionId(gaSessionIds),
      gaSessionIds: gaSessionIds,
      cartReadFailures: cartReadFailures.length > 0 ? cartReadFailures : undefined
    };

    if (bodyBytes(payload) > CHECKOUT_BODY_BUDGET_BYTES) payload.items = items.map(toVisibleLineItem);
    if (bodyBytes(payload) > CHECKOUT_BODY_BUDGET_BYTES) payload.items = items.map(toLineTriple);

    postCheckout(flow, attempt, payload);
  }

  /* Executa uma requisição em tentativas, com a regra que a rede móvel pede. Uma tentativa que passa de
     policy.patienceMs sem resposta ganha outra em paralelo, sem ser abortada: numa rede lenta ela ainda está
     progredindo, e abortá-la para recomeçar do zero falharia de novo pelo mesmo motivo; se ela estava presa
     numa conexão que a rede derrubou em silêncio, a nova a contorna. A tentativa que falha na rede (send
     rejeitada) repete depois de policy.retryDelaysMs[número dela - 1] (0 repete na hora), até
     policy.maxAttempts, contando as paralelas. A paralela por lentidão só sai enquanto o total iniciado for
     menor que policy.maxSlowAttempts (sem ele, policy.maxAttempts). A primeira resposta de sucesso vence.

     send(attemptNumber, failures) resolve { result } no sucesso ou { refusal } numa resposta definitiva sem
     sucesso, que não repete, porque daria o mesmo resultado, mas espera as tentativas ainda em voo. failures
     traz as tentativas já superadas ({ elapsedMs, errorMessage, pageAgeMs }, com "slow" para a lenta).

     retryNow antecipa a próxima tentativa agendada, quando o chamador sabe que vale tentar já.

     settle é chamado uma vez: com { result, failures }, ou com { refusal, error, failures, attempts,
     lastStartedAt } quando todas falharam ou o prazo do chamador venceu (expire). Depois de cancel, nunca é
     chamado. */
  function runAttempts(policy, send, settle) {
    var failures = [];
    var started = 0;
    var pending = 0;
    var done = false;
    var lastStartedAt = Date.now();
    var refusal = null;
    var timers = [];
    var scheduledRetry = null;

    function stop() {
      done = true;
      for (var i = 0; i < timers.length; i++) clearTimeout(timers[i]);
    }

    function fail(error) {
      if (done) return;
      stop();
      settle({
        refusal: refusal,
        error: error,
        failures: failures,
        attempts: started,
        lastStartedAt: lastStartedAt
      });
    }

    function start() {
      started += 1;
      pending += 1;
      lastStartedAt = Date.now();

      var attemptNumber = started;
      var attemptStartedAt = lastStartedAt;
      var superseded = false;

      function supersede(reason) {
        if (superseded) return;
        superseded = true;
        failures.push({
          elapsedMs: Date.now() - attemptStartedAt,
          errorMessage: reason,
          pageAgeMs: pageAgeMs()
        });
      }

      var patienceTimer = setTimeout(function() {
        var slowAttemptsCap = policy.maxSlowAttempts || policy.maxAttempts;
        if (done || started !== attemptNumber || started >= slowAttemptsCap) return;
        supersede("slow");
        start();
      }, policy.patienceMs);
      timers.push(patienceTimer);

      send(attemptNumber, failures.slice())
        .then(
          function(outcome) {
            clearTimeout(patienceTimer);
            pending -= 1;
            if (done) return;

            if (outcome.result !== undefined) {
              stop();
              settle({ result: outcome.result, failures: failures });
              return;
            }

            refusal = outcome.refusal;
            if (pending === 0) fail();
          },
          function(error) {
            clearTimeout(patienceTimer);
            pending -= 1;
            if (done) return;

            if (started < policy.maxAttempts) {
              supersede(errorMessage(error));
              var delay = policy.retryDelaysMs[attemptNumber - 1];
              if (!delay) {
                start();
                return;
              }
              scheduledRetry = setTimeout(function() {
                scheduledRetry = null;
                if (!done && started < policy.maxAttempts) start();
              }, delay);
              timers.push(scheduledRetry);
              return;
            }

            if (pending === 0) fail(error);
          }
        )
        .catch(fail);
    }

    start();

    return {
      expire: fail,
      cancel: stop,
      retryNow: function() {
        if (done || scheduledRetry === null) return;
        clearTimeout(scheduledRetry);
        scheduledRetry = null;
        if (started < policy.maxAttempts) start();
      },
      progress: function() {
        return { attempts: started, failures: failures.slice() };
      }
    };
  }

  /* Toda tentativa repete o corpo inteiro: uma sessão de checkout criada por uma tentativa superada fica sem
     uso, sem reserva de estoque nem cobrança. As superadas vão em previousFailures para o backend registrar
     quem a nova salvou. A falha de rede repete na hora (o POST costuma cair numa conexão que a rede móvel
     derrubou em silêncio, e a seguinte passa) e depois com as mesmas esperas da leitura do carrinho, até o
     fim do prazo: sem rede, o checkout nativo também não carregaria. A paralela por lentidão para em
     CHECKOUT_MAX_SLOW_ATTEMPTS, porque numa rede lenta uma tentativa a mais só disputa a conexão com a que
     está progredindo. O checkout nativo só vem quando as tentativas acabam ou quando passa
     CHECKOUT_PATIENCE_BUDGET_MS do início do POST, com o aviso na tela o tempo todo. */
  function postCheckout(flow, attempt, payload) {
    flow.timers.push(setTimeout(function() {
      flow.run.expire(new Error("timeout"));
    }, CHECKOUT_PATIENCE_BUDGET_MS));

    flow.run = runAttempts(
      {
        maxAttempts: CHECKOUT_MAX_ATTEMPTS,
        maxSlowAttempts: CHECKOUT_MAX_SLOW_ATTEMPTS,
        patienceMs: CHECKOUT_ATTEMPT_PATIENCE_MS,
        retryDelaysMs: CHECKOUT_RETRY_DELAYS_MS
      },
      function(attemptNumber, failures) {
        if (failures.length > 0) payload.previousFailures = failures;
        return sendCheckout(payload);
      },
      function(outcome) {
        if (outcome.result) {
          endFlow();
          handedOff = true;
          /* Mantém resolveInFlight travado: já estamos navegando, evita 2º POST. */
          window.location.href = outcome.result;
          return;
        }

        giveUpCheckout(attempt, outcome);
      }
    );
  }

  /* Corpo que não é JSON (página de erro do WAF/ALB, 200 vazio) não pode virar erro de parse: o status HTTP é
     o que diagnostica o fallback. */
  function sendCheckout(payload) {
    return fetch(CHECKOUT_URL, {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify(payload)
    }).then(function(response) {
      return response.json()
        .catch(function() { return null; })
        .then(function(data) {
          if (data && data.checkoutUrl) return { result: data.checkoutUrl };

          return {
            refusal: {
              httpStatus: response.status,
              errorCode: data && typeof data.code === "string" ? data.code : undefined
            }
          };
        });
    });
  }

  /* Em falha na resolução, o comprador vai ao /checkout nativo da Shopify em vez de ficar preso na página sem
     resposta. Uma resposta do backend sem a URL diagnostica melhor que a falha de rede: se alguma tentativa
     voltou assim, é ela que vai no report, com o status e o código de erro. */
  function giveUpCheckout(attempt, outcome) {
    if (outcome.refusal) {
      fallBackToNative("no_checkout_url", attempt, {
        httpStatus: outcome.refusal.httpStatus,
        errorCode: outcome.refusal.errorCode,
        attempts: outcome.attempts
      });
      return;
    }

    console.error("[bestfy] checkout resolve failed", outcome.error);
    var previousFailures = outcome.failures.length > 0 ? outcome.failures : undefined;
    fallBackToNative(
      "api_error",
      attempt,
      failureDetails(outcome.error, outcome.lastStartedAt, outcome.attempts, previousFailures)
    );
  }

  /* Regra única de roteamento pelo status: age na hora quando ativo, retém a ação enquanto o
     status resolve e cai para o caminho nativo só quando a integração está inativa; status
     desconhecido segue o nosso fluxo (ver warmStatus). A ação retida espera o status por no máximo
     HELD_STATUS_WAIT_MS: um GET /status preso deixaria o comprador olhando o aviso para sempre, e seguir
     com o status desconhecido custa só um resolve, que recusa a loja inativa. */
  function whenActive(attempt, run, fallback) {
    waitingAttempt = attempt;
    if (activeState === true) {
      run(attempt);
      return;
    }
    var statusWait = new Promise(function(resolve) {
      setTimeout(function() {
        resolve(null);
      }, HELD_STATUS_WAIT_MS);
    });

    Promise.race([statusPromise, statusWait]).then(function(active) {
      if (buyerLeaving) return;
      if (active === false) {
        reportFallback("integration_inactive", attempt);
        fallback(attempt.el);
        return;
      }
      run(attempt);
    });
  }

  /* Reenvia o formulário pelo caminho nativo: form.submit() ignora todos os
     listeners de submit (nossos e do tema) e faz o POST /cart/add puro, que a
     Shopify trata sozinha (302 para /cart ou página de erro). Usado quando a
     adição via AJAX falha ou quando o status resolve inativo. */
  function replayNativeAdd(form) {
    if (replayedNativeAdd || buyerLeaving) return;
    replayedNativeAdd = true;
    form.submit();
  }

  function addThenResolve(attempt) {
    if (addInFlight) return;
    addInFlight = true;

    var form = attempt.el;
    var generation = clickGeneration;

    /* O /cart/add.js não pode ser cancelado. Se a página voltou ao estado de antes do clique com a requisição
       em voo (resetClickState), a resposta pertence a um clique encerrado e não navega. */
    fetch("/cart/add.js", { method: "POST", body: new FormData(form) })
      .then(function(response) {
        if (generation !== clickGeneration) return;
        if (response.ok) {
          /* Mantém addInFlight travado: seguimos para o resolve e a navegação. */
          resolveCheckout(attempt);
          return;
        }
        addInFlight = false;
        replayNativeAdd(form);
      })
      .catch(function(error) {
        if (generation !== clickGeneration) return;
        addInFlight = false;
        console.error("[bestfy] cart add failed", error);
        replayNativeAdd(form);
      });
  }

  document.addEventListener("click", function(e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var labeled = findLabeledTrigger(e.target);
    var trigger = labeled || findTrigger(e.target);

    if (!trigger) return;
    // Já indo ao nativo: um resolve novo seria abortado pela navegação e reportado como falha falsa.
    if (activeState === false || wentNative) return;

    e.preventDefault();
    e.stopPropagation();
    showProgressNotice();
    whenActive(
      { rule: labeled ? "labeled" : "structural", el: trigger },
      resolveCheckout,
      goNative
    );
  }, true);

  /* Enter num campo dispara submit. Só interceptamos formulários que postam
     direto para /checkout; nunca o form do carrinho (action /cart), pois lá o
     Enter normalmente aciona "atualizar", não "finalizar". */
  document.addEventListener("submit", function(e) {
    var form = e.target;
    if (!form || lc(form.tagName) !== "form") return;
    if (!leadsToCheckout(pathOf(attr(form, "action")))) return;
    if (activeState === false || wentNative) return;

    e.preventDefault();
    e.stopPropagation();
    showProgressNotice();
    whenActive({ rule: "checkout_form_submit", el: form }, resolveCheckout, goNative);
  }, true);

  /* Pular carrinho: ouvimos o submit do formulário de produto em fase de
     bolha, DEPOIS dos handlers do tema. Se o tema já tratou o submit
     (preventDefault, caso dos carrinhos AJAX de gaveta), não tocamos em nada e
     adicionar ao carrinho segue adicionando. Se ninguém tratou, o navegador
     faria o POST /cart/add nativo e aterrissaria na página /cart; é esse
     desvio que pulamos: a adição acontece via /cart/add.js e seguimos direto
     para o resolve do checkout. */
  if (SKIP_CART) {
    document.addEventListener("submit", function(e) {
      if (e.defaultPrevented) return;
      var form = e.target;
      if (!form || lc(form.tagName) !== "form") return;
      if (!leadsToCartAdd(pathOf(attr(form, "action")))) return;
      if (activeState === false || wentNative) return;

      e.preventDefault();
      e.stopPropagation();
      showProgressNotice();
      whenActive({ rule: "skip_cart_add", el: form }, addThenResolve, replayNativeAdd);
    }, false);
  }

  /* O form do carrinho posta em /cart e a Shopify só redireciona ao checkout no servidor; o que o denuncia é
     o campo checkout no corpo, que vem do botão que enviou o form. */
  function isNativeCheckoutNavigation(e) {
    var url;
    try {
      url = new URL(e.destination.url);
    } catch (error) {
      return false;
    }

    var isStoreHost =
      url.origin === window.location.origin || url.hostname.slice(-14) === ".myshopify.com";
    if (!isStoreHost) return false;

    var path = pathOf(url.pathname);
    if (leadsToCheckout(path)) return true;

    return isCartPath(path) && !!e.formData && e.formData.has("checkout");
  }

  /* Rede de segurança dos listeners de clique e submit: a Navigation API avisa toda navegação que a própria
     página inicia, então pega o que a heurística não reconhece, como o location.href = "/checkout" que o tema
     faz depois de um AJAX ou o form.submit() de um app. Navegação do usuário pela barra de endereço não é
     cancelável e passa. Navegador sem a API fica só com os listeners. */
  if (window.navigation && window.navigation.addEventListener) {
    window.navigation.addEventListener("navigate", function(e) {
      if (!e.cancelable || activeState === false || wentNative || buyerLeaving) return;
      if (!isNativeCheckoutNavigation(e)) return;

      e.preventDefault();
      showProgressNotice();
      whenActive({ rule: "navigation", el: null }, resolveCheckout, goNative);
    });
  }

  /* O comprador que recarrega, volta ou fecha a página com o aviso na tela não chega a checkout nenhum e, sem
     este report, sumiria sem rastro; é ele que mostra se a espera trocou o fallback por abandono. */
  function reportBuyerLeft() {
    var details = { elapsedMs: Date.now() - noticeShownAt, waitingFor: waitingStage() };
    if (activeFlow) {
      var progress = activeFlow.run.progress();
      details.attempts = progress.attempts;
      details.previousFailures = progress.failures.length > 0 ? progress.failures : undefined;
    }

    endFlow();
    reportFallback("buyer_left", waitingAttempt, details);
  }

  /* As navegações do próprio script também disparam o beforeunload e o pagehide e não são abandono: para o
     nosso checkout (handedOff), para o nativo (wentNative) e o reenvio nativo do formulário do pular carrinho
     (replayedNativeAdd). */
  function isWaitingBuyer() {
    var leftByScript = handedOff || wentNative || replayedNativeAdd;
    return noticeShownAt !== null && !!waitingAttempt && !leftByScript;
  }

  /* Recarregar, voltar ou digitar outro endereço não descarta a página na hora: ela segue viva, com os timers
     correndo, até a resposta da nova chegar, o que numa rede lenta leva segundos. Um fallback ou a URL do
     checkout que chegasse nesse intervalo navegaria por cima e levaria o comprador a um checkout que ele não
     pediu. O beforeunload é o sinal que chega antes disso para todas essas saídas (o navigate da Navigation
     API não dispara no recarregar); a navegação para o /checkout que a guarda intercepta não o dispara. Ele
     só fica registrado enquanto o aviso está na tela, porque no Firefox o listener tira a página do
     bfcache. */
  function abandonWait() {
    if (buyerLeaving || !isWaitingBuyer()) return;

    reportBuyerLeft();
    buyerLeaving = true;
    leavingGraceTimer = setTimeout(resetClickState, LEAVING_GRACE_MS);
  }

  /* Uma saída que não acontece (navegação abortada, destino 204, confirmação de saída recusada) deixaria o
     comprador preso no aviso: a página volta ao estado de antes do clique, sem navegar. O navigateerror avisa
     o aborto onde a Navigation API existe; o timer cobre o resto, inclusive o destino 204, que não o dispara.
     Se a navegação do comprador só estava lenta, ele vê a página antiga até a nova chegar, como sem o
     script. */
  if (window.navigation && window.navigation.addEventListener) {
    window.navigation.addEventListener("navigateerror", function() {
      if (buyerLeaving) resetClickState();
    });
  }

  window.addEventListener("online", function() {
    if (activeFlow) activeFlow.run.retryNow();
  });

  window.addEventListener("pagehide", function() {
    if (buyerLeaving || !isWaitingBuyer()) return;

    reportBuyerLeft();
    noticeShownAt = null;
  });

  function waitingStage() {
    if (activeFlow) return activeFlow.readingCart ? "cart" : "checkout";
    return addInFlight ? "cart_add" : "status";
  }

  /* O comprador volta da nossa tela com o botão voltar e reencontra esta página
     como ela foi pintada antes das edições dele: o navegador restaura do bfcache
     ou serve o HTML do cache sem revalidar, e a navegação de histórico não é um
     caminho que a gente possa influenciar. O carrinho da loja já foi atualizado
     pelo backend enquanto ele editava, então aqui basta reler o vivo e recarregar
     quando divergir. Recarregar é o único caminho: quem sabe pintar o carrinho é
     o tema, e o markup dele muda de loja para loja.

     A assinatura vale uma volta só e é consumida aqui. É isso que torna a
     comparação confiável: a primeira conferência depois do handoff é o retorno à
     página que ele deixou, então a assinatura guardada é exatamente o que aquela
     página pintou. Deixá-la viva depois disso a transformaria em "o carrinho de
     algum momento anterior", que não descreve mais nenhuma tela. */
  function checkStoreCartOnReturn() {
    var remembered = cacheGet(CART_SIGNATURE_KEY);

    if (remembered === null) return;

    cacheRemove(CART_SIGNATURE_KEY);

    fetch("/cart.json", { cache: "no-store" })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        if (cartSignature(cart) === remembered) return;

        window.location.reload();
      })
      .catch(function() {
        /* Sem a leitura do carrinho não dá para saber se a página está velha, e
           recarregar no escuro custaria uma navegação a cada volta. */
      });
  }

  /* Só a navegação de histórico reaproveita HTML velho. O comprador que chega por
     um link (a logo do checkout leva de volta à loja) recebe a página pintada com
     o carrinho já espelhado, e conferir ali custaria um reload à toa. A assinatura
     é consumida mesmo assim, porque não descreve mais nenhuma tela. Sem a Navigation
     Timing no navegador, a conferência segue valendo para toda execução. */
  function isHistoryNavigation() {
    var entries = window.performance && window.performance.getEntriesByType
      ? window.performance.getEntriesByType("navigation")
      : [];

    if (!entries.length) return true;

    return entries[0].type === "back_forward";
  }

  /* Na volta servida pelo cache de HTTP o script reexecuta, então conferimos já
     na execução, com o HTML recém-parseado: o reload aborta o carregamento em
     andamento em vez de esperar o load, que numa loja Shopify ainda vai levar
     segundos baixando imagem, pixel e app de terceiro. */
  if (isHistoryNavigation()) {
    checkStoreCartOnReturn();
  } else {
    cacheRemove(CART_SIGNATURE_KEY);
  }

  /* Devolve a página ao estado de antes do clique. Os retries agendados e os prazos do clique são cancelados
     (endFlow): congelados no bfcache, eles voltariam a correr na página restaurada e levariam o comprador ao
     checkout sem um clique novo. */
  function resetClickState() {
    clickGeneration += 1;
    clearTimeout(leavingGraceTimer);
    endFlow();
    releaseResolve();
    hideProgressNotice();
    addInFlight = false;
    replayedNativeAdd = false;
    wentNative = false;
    handedOff = false;
    buyerLeaving = false;
    waitingAttempt = null;
  }

  /* Restauração do bfcache não reexecuta o script, e é o único caminho de volta
     que o pageshow enxerga e a execução acima não.

     As travas de "já estou tratando" são mantidas ligadas de propósito enquanto
     navegamos para o nosso checkout, para um segundo clique não disparar um
     segundo POST. O bfcache devolve o heap como estava, então elas voltam
     ligadas e engoliriam o próximo clique inteiro: o listener já cancelou o
     evento quando descobre que não vai fazer nada, e o comprador fica sem o
     nosso fluxo e sem o nativo. Para ele a página restaurada é uma visita nova,
     então as travas recomeçam zeradas. */
  window.addEventListener("pageshow", function(e) {
    if (!e.persisted) return;

    resetClickState();
    checkStoreCartOnReturn();
  });

  try {
    saveUtms();
    saveClickId("tblci", TBLCI_COOKIE, 512);
    saveClickId("fbclid", FBCLID_COOKIE, 500);
    saveClickId("gclid", GCLID_COOKIE, 512);
  } catch (error) {
    return;
  }
})();